
















import Component from "vue-class-component";
import Controls from "./Controls.vue";
import Grid from "./Grid.vue";
import { LifeRenderProps } from "./LifeRenderProps";

@Component({
  components: { Controls, Grid },
})
export default class App extends LifeRenderProps {}
